import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useHighFrequencyRefreshQuery} from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import {ITestKitOrder, TestKitOrder} from '../TestKitOrder.ts';
import {TestKitOrderApi} from '../../../apis/TestKitOrderApi/TestKitOrderApi.ts';
import {useIdFromRoute} from '../../../hooks/useIdFromRoute.tsx';

export function useGetTestKitOrderById() {
    const id = useIdFromRoute();
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.testkitorder, id],
        queryFn: async () => {
            const result: ITestKitOrder = await TestKitOrderApi.getTestKitOrdersById(id);
            return new TestKitOrder(result);
        },
        enabled: !!id
    });
}